<div class="modal-content__body-container" *ngIf="loading">
  <div class="empty-container">
    <app-spinner-loader class="intern"></app-spinner-loader>
  </div>
</div>
